import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MaskedFormControl from "react-bootstrap-maskedinput";
import { reqData } from "../../../js/server";
import { useHistory } from "react-router-dom";
import SubBanner from "../../comm/SubBanner";

function JoinStep02(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [comIdno, setComIdno] = useState("");

  useEffect(
    () => {
      dispatch({
        type: "pageChange",
        payload: { sub01: "회원가입", sub02: "조합원인증" },
      });
      dispatch({ type: "loadingChange", payload: true });

      setTimeout(() => {
        localStorage.removeItem("authComInfo");
        dispatch({ type: "loadingChange", payload: false });
      }, 500);
    },
    // eslint-disable-next-line
    []
  );

  const fnIdnoCheckClick = () => {
    if (comIdno.length !== 12) {
      alert("사업자등록번호를 정확히 입력해 주세요.");
      document.getElementById("inputComidno").focus();
    } else {
      //조합원 인증 체크
      const jsonData = {
        servicename: "ShopSearch",
        comIdno: comIdno.replace(/-/gi, ""),
      };
      console.log(jsonData);
      dispatch({ type: "loadingChange", payload: true });
      reqData(jsonData)
        .then((res) => {
          console.log(res);
          if (res.data.result === "OK") {
            const resData = res.data.jsonData;
            localStorage.setItem("authComInfo", JSON.stringify(resData));

            alert("조합원 인증에 성공하였습니다. 회원가입으로 이동합니다.");
            history.push("/JoinStep03");
          } else {
            alert("조합원 정보를 찾을 수 없습니다.");
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          dispatch({ type: "loadingChange", payload: false });
        });
    }
  };

  return (
    <>
      <SubBanner id="member" />

      <section className="appoinment section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-2"></div>

            <div className="col-lg-6 col-md-8">
              <div className="row">
                <div className="joinstep-container">
                  <div className="joinstep">
                    <span>01</span>
                    <span>이용약관동의</span>
                  </div>
                  <div className="joinstep active">
                    <span>02</span>
                    <span>조합원인증</span>
                  </div>
                  <div className="joinstep">
                    <span>03</span>
                    <span>회원가입</span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <p>
                    조합원 신청을 통하여 기등록된 조합원만 가입이 가능합니다.
                    <br />
                    사업자등록번호를 통해 인증을 완료해 주세요.
                  </p>
                </div>
              </div>

              <div className="row round-box">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label className="form-control-label">
                          사업자등록번호
                        </label>
                        <MaskedFormControl
                          type="text"
                          id="inputComidno"
                          name="inputComidno"
                          mask="111-11-11111"
                          onChange={(e) => setComIdno(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 font-size-8">
                      인증에 실패되거나 별도 가입을 원하시는 분들은 메인화면의
                      조합원 가입하기를 통해 절차를 다시 확인해 주시기 바랍니다.
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-lg-12 col-md-12 text-right">
                      <span
                        className="btn btn-main btn-icon btn-round-full"
                        onClick={fnIdnoCheckClick}
                      >
                        다음
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-2"></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default JoinStep02;
